export default {
    layout: {
        zh: '简体中文',
        zhTw: '繁体中文',
        en: '英语',
        kr: '韩语',
        jp: '日语',
        copyAddress: '复制地址',
        switchWallet: '切换钱包',
        disconnect: '断开连接',
        copied: '复制成功',
        failed:'失败',
        success:'成功',
    },
    node: {
        progress: '交易进行中',
        executionSuccessful: '执行成功',
        at: '在',
        view: '查看',
    },
    menu: {
        home: '首页',
        exchange: '兑换',
        mining: '挖矿',
        assets: '资产',
        earnings: '收益',
        me: '我的',
        notice: '公告',
    },
    exchange: {
        title: '兑换',
        send: '发送',
        receive: '接收',
        obtain: '获得',
        consume: '消耗',
        balance: '资产余额',
        max: '最大',
        currentPrice: '当前价格',
        submit: '兑换',
        records: '兑换记录',
        price: '价格',
        success: '成功',
        fail: '失败',
    },
    home: {
        brand: 'OnOx',
        slogan: '连接全球 赋能未来',
        sloganDesc: '去中心化·更开放·更高效',
        yield: '收益率',
        notice: '公告1，ABC挖矿上线运营',
        todayOutput: '今日矿池产出',
        networkHashrate: '全网有效算力',
        price: '当前币价',
        burned: '总消毁量',
        aboutTitle: '关于ONOX算力挖矿',
        aboutDesc: 'ONOX连接真实算力节点，将设备产出、收益结算与资产管理整合于一个可信赖的移动端账户。',
        featureHashrate: '真实算力接入',
        featureHashrateDesc: '节点状态透明，算力数据实时更新',
        featureDaily: '每日收益结算',
        featureDailyDesc: '按有效算力计费，收益记录清晰可追溯',
        featureSecurity: '数字资产安全',
        featureSecurityDesc: '钱包地址绑定，提现操作多重验证',
        bindTitle: '绑定邀请地址',
        bindConfirm: '确认绑定',
        bindPlaceholder: '0x000000000000000000000000000000',
    },
    mining: {
        title: '燃烧挖矿',
        subtitle: '激活算力 共享生态收益',
        totalT: '总算力 (T)',
        shareT: '分享算力',
        teamT: '团队算力',
        burnT: '燃烧算力',
        validBurnT: '有效燃烧算力',
        renew: '续约',
        amountPlaceholder: '请输入燃烧算力数值',
        token: '燃烧币种',
        rate: '实时换算',
        balance: '钱包余额',
        submit: '参与燃烧挖矿',
        hint: '实际可获得',
        burnLog: '燃烧记录',
        shareLog: '分享算力',
        renewLog: '续约记录',
        success: '成功',
        fail: '失败',
        qty: '数量',
        hashrateT: '算力 (T)',
        renewHashrate: '上月挖矿收益',
        renewFee: '续约费用',
        renewDate: '算力日期',
        renewConvert: '折算数量',
        renewNote: '说明',
        renewNoteText: ' 日前续约，逾期将无法获得挖矿收益。',
        renewConfirm: '确认续约',
        ext1:'奖励算力',
        ext2:'挖矿收益',
        ext3:'续约金额'
    },
    earnings: {
        balance: '资产余额',
        recharge: '去充值',
        withdraw: '去提现',
        totalWithdraw: '累计提币',
        totalIncome: '总收益',
        mineIncome: '挖矿收益',
        referral: '推荐奖励',
        incomeLog: '收益记录',
        rechargeLog: '充值记录',
        withdrawLog: '提现记录',
        qty: '数量',
        success: '成功',
        pending: '待转账',
        fail: '失败',
        1: '成功',
        0: '待转账',
        2: '失败',
        rechargeQty: '充值数量',
        withdrawQty: '提现数量',
        receiveQty: '到账数量',
        rechargeTitle: '充值',
        withdrawTitle: '提现',
        rechargeMin: '不能小于10',
        minAmount: '不能小于100',
        toAccount: '提现到账',
        fee: '手续费',
        rechargeAddress: '充值地址',
        address: '提现地址',
        confirmRecharge: '确认充值',
        confirmWithdraw: '确认提币',
    },
    me: {
        inviteLink: '我的邀请链接',
        upline: '上级地址',
        inviteCount: '邀请人数',
        teamCount: '团队人数',
        bigArea: '大区算力 (T)',
        smallArea: '小区总燃烧算力 (T)',
        team: '直推成员',
        direct: '直推',
        indirect: '间推',
        umbrella: '伞下',
        burnT: '燃烧算力 (T)',
        personT: '个人算力 (T)',
        teamBurn: '团队燃烧算力 (T)',
        teamHash: '团队算力 (T)',
        remark: '备注',
        setRemark: '设置备注',
        remarkPlaceholder: '请输入备注',
        confirm: '确认',
    },
    notice: {
        title: '公告详情',
        headline: '大标题大标题大标题大标题',
        date: '2024-12-22',
        body: '尊敬的用户：\n您好！\nXXXApp将于2024年11月26日晚上8点正式上线，同时最低认购基础也将同步更新，其他不变，具体认购基础以App显示为准。\n同时由于苹果版还在审核，因此先上线安卓版本，苹果手机需等待审核通过后才能下载，届时在Dapp将开放安卓版本下载端口，尽情留意。',
    },
};
